import { getMedicalSegmentFromSegments, getPharmacySegmentFromSegments } from "./segments";
import vars from "utils/vars";

const isDefaultLocale = (locale = "") =>
	locale.toLowerCase().split("-")[0] === (vars?.app?.defaultLocale || "").toLowerCase();

const getRouteLocalePrefix = (language = "") =>
	!isDefaultLocale(language) ? `/${language.toLowerCase().split("-")[0]}` : "";

export const isMedicalOrPharmacyNoteFormSegment = (globals = {}, segments = []) => {
	const segmentId = globals?.segment?.id;
	if (!segmentId) return false;
	const medicalSegment = getMedicalSegmentFromSegments(segments);
	const pharmacySegment = getPharmacySegmentFromSegments(segments);
	return medicalSegment?.id === segmentId || pharmacySegment?.id === segmentId;
};

export const noteHasFillablePdf = (note = {}) =>
	Boolean(note?.cases?.some((caseItem) => Boolean(+caseItem?.has_fillable_pdf)));

// HCP stamping still requires a fillable PDF on the same case.
const noteHasFillablePdfCaseWith = (note = {}, configKey = "") =>
	Boolean(
		note?.cases?.some(
			(caseItem) => Boolean(+caseItem?.has_fillable_pdf) && isTruthyCaseConfig(caseItem?.[configKey])
		)
	);

const isTruthyCaseConfig = (value) => value === true || value === 1 || value === "1";

const noteHasCaseWith = (note = {}, configKey = "") =>
	Boolean(note?.cases?.some((caseItem) => isTruthyCaseConfig(caseItem?.[configKey])));

export const extractNoteFromApiPayload = (payload = {}) => payload?.note || payload?.data?.note || null;

export const mergeNoteFromApiPayload = (currentNote = {}, payload = {}, fallbackId = "") => {
	const fetched = extractNoteFromApiPayload(payload) || {};
	return {
		...(currentNote || {}),
		...fetched,
		id: fetched.id || currentNote?.id || fallbackId,
		cases: fetched.cases ?? currentNote?.cases ?? [],
		has_patient_signature: fetched.has_patient_signature ?? currentNote?.has_patient_signature ?? false,
	};
};

export const noteRequiresHcpSignature = (note = {}) => noteHasFillablePdfCaseWith(note, "collect_hcp_signature");

export const noteRequiresPatientSignature = (note = {}) =>
	noteHasCaseWith(note, "collect_patient_signature");

export const shouldUseSubmitNoteSignatureModal = ({ isElectronicFormOrder, isReferral, note }) =>
	!isElectronicFormOrder && !isReferral && noteRequiresHcpSignature(note);

export const shouldIncludeOrderSignatureInNoteSubmit = ({ isElectronicFormOrder, isReferral, note }) =>
	Boolean(isElectronicFormOrder || isReferral || noteRequiresHcpSignature(note));

export const getNoteAfterSavedPath = ({ language, noteId, isDemo = false, isPlan = false }) =>
	`${getRouteLocalePrefix(language)}${
		isDemo ? `/demo${!isPlan ? `/finish` : `/notes/edit/${noteId}/final`}` : `/notes/${noteId}?after_note_saved=1`
	}`;

export const redirectToNoteAfterSaved = ({ language, noteId, isDemo = false, isPlan = false }) => {
	if (!noteId || typeof window === "undefined") return;
	window.location.assign(getNoteAfterSavedPath({ language, noteId, isDemo, isPlan }));
};

export const planSubmitNoteIntent = { isSaveAction: false, isPlan: true };

export const finalSubmitNoteIntent = { isSaveAction: false, isPlan: false };

export const defaultSubmitNoteIntent = { isSaveAction: false, isPlan: false };
